import { Form, Formik } from "formik";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import SunEditor from "suneditor-react";

import { UploadOutlined } from "@ant-design/icons";
import { Button, Card, Col, Divider, Row, Space, Upload } from "antd";
import { Input, RadioGroup, Select, Switch } from "components/form";

import "suneditor/dist/css/suneditor.min.css";
import schema, {
  policyInitialValues as INITIAL_VALUES,
} from "../schemas/policySchema";
import styles from "../styles/Policy.module.css";

function PolicyForm({
  isCreate = true,
  isLoading = false,
  initialValues = {},
  policyCategory = [],
  onSubmit = () => { },
  onCancel = () => { },
}) {
  const { t } = useTranslation();
  console.log("fomr ", initialValues);
  const [attachments, setAttachments] = useState([]);

  useEffect(() => {
    setAttachments(initialValues.attachment || []);
  }, [initialValues.attachment]);

  return (
    <Formik
      enableReinitialize
      initialValues={
        isCreate
          ? { ...INITIAL_VALUES }
          : { ...INITIAL_VALUES, ...initialValues }
      }
      onSubmit={onSubmit}
      validationSchema={schema}
    >
      {({ values = {}, setFieldValue = () => { } }) => {
        return (
          <Form className={styles.container}>
            <Space size={24} direction="vertical">
              <Card style={{ border: "1px solid #EAECF0" }}>
                <Row justify="space-between">
                  <b className={styles.infoTopic}>
                    {t("policy.label.policy_detail")}
                  </b>
                </Row>
                <Divider />
                <Row gutter={[0, 16]}>
                  <Col span={12} style={{ paddingRight: "12px" }}>
                    <Input
                      name="policyCode"
                      label={
                        t("policy.label.policy_code") +
                        t("common.required_field_suffix")
                      }
                      placeholder={
                        t("policy.label.policy_code") +
                        t("common.required_field_suffix")
                      }
                      size="large"
                    />
                  </Col>
                  <Col span={12} style={{ paddingLeft: "12px" }}>
                    <Input
                      name="policyName"
                      label={
                        t("policy.label.policy_name") +
                        t("common.required_field_suffix")
                      }
                      placeholder={
                        t("policy.label.policy_name") +
                        t("common.required_field_suffix")
                      }
                      size="large"
                    />
                  </Col>
                  <Col span={12} style={{ paddingRight: "12px" }}>
                    <Select
                      name="policyCategoryId"
                      label={
                        t("policy.label.category") +
                        t("common.required_field_suffix")
                      }
                      placeholder={
                        t("policy.label.category") +
                        t("common.required_field_suffix")
                      }
                      size="large"
                      options={policyCategory}
                    />
                  </Col>
                  <Col span={6} style={{ paddingLeft: "12px" }}>
                    <RadioGroup
                      name="detailType"
                      label={
                        t("policy.label.detail") +
                        t("common.required_field_suffix")
                      }
                      options={[
                        {
                          label: t("policy.label.paragraph"),
                          value: "paragraph",
                        },
                        {
                          label: t("policy.label.link_attached"),
                          value: "linkAttached",
                        },
                      ]}
                    />
                  </Col>
                  <Col span={6}>
                    <label>{t("policy.label.acknowledge")}</label>
                    <div style={{ height: 8 }} />
                    <Switch name="acknowledge" />
                  </Col>
                  {values.detailType === "linkAttached" ? (
                    <Col span={24}>
                      <Input
                        name="link"
                        label={
                          t("policy.label.external_link") +
                          t("common.required_field_suffix")
                        }
                        placeholder={
                          t("policy.label.external_link") +
                          t("common.required_field_suffix")
                        }
                        size="large"
                      />
                    </Col>
                  ) : (
                    <>
                      <Col span={24}>
                        <p>{t("policy.label.detail")}</p>
                        {values.policyId && values.description ? (
                          <SunEditor
                            name="description"
                            defaultValue={values.description}
                            width="100%"
                            setContents={values.description}
                            onChange={(content) =>
                              setFieldValue("description", content)
                            }
                          />
                        ) : (
                          <SunEditor
                            name="description"
                            width="100%"
                            onChange={(content) =>
                              setFieldValue("description", content)
                            }
                          />
                        )}
                      </Col>
                      <Col span={24}>
                        <p>{t("policy.label.attachment")}</p>
                      </Col>
                      <Col span={24}>
                        <Upload
                          name="attachment"
                          action={null}
                          beforeUpload={(file) => {
                            const modifiedAttachment = {
                              content: file,
                              fileName: file.name,
                              ext: file.type,
                            };
                            const newAttachments = [
                              ...attachments,
                              modifiedAttachment,
                            ];
                            setAttachments(newAttachments);
                            setFieldValue("attachment", newAttachments);
                            return false;
                          }}
                          onRemove={(file) => {
                            const bufferAttachments = [...attachments];
                            const index = bufferAttachments.indexOf(file);
                            const newFileList = bufferAttachments.slice();
                            newFileList.splice(index, 1);
                            setAttachments(newFileList);
                            setFieldValue("attachment", newFileList);
                          }}
                          fileList={attachments.map((a) => a.content)}
                        >
                          <Button htmlType="button" type="default">
                            <UploadOutlined />
                            {t("common.upload")}
                          </Button>
                        </Upload>
                      </Col>
                    </>
                  )}
                </Row>
                <Row justify="end" style={{ paddingTop: "24px" }}>
                  <Space size={12}>
                    <Button type="default" onClick={onCancel} style={{ height: "40px", borderRadius: "8px" }}>
                      {t("common.cancel").toUpperCase()}
                    </Button>
                    <Button
                      type="primary"
                      htmlType="submit"
                      disabled={isLoading}
                      style={{ height: "40px", borderRadius: "8px", backgroundColor: "var(--button-color)" }}
                    >
                      {isCreate
                        ? t("common.create").toUpperCase()
                        : t("common.save").toUpperCase()}
                    </Button>
                  </Space>
                </Row>
              </Card>
            </Space>
          </Form>
        );
      }}
    </Formik>
  );
}

export default PolicyForm;
